import { render, staticRenderFns } from "./PublishSharedLink.vue?vue&type=template&id=d7bf1480&scoped=true"
import script from "./PublishSharedLink.vue?vue&type=script&lang=ts"
export * from "./PublishSharedLink.vue?vue&type=script&lang=ts"
import style0 from "./PublishSharedLink.vue?vue&type=style&index=0&id=d7bf1480&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bf1480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7bf1480')) {
      api.createRecord('d7bf1480', component.options)
    } else {
      api.reload('d7bf1480', component.options)
    }
    module.hot.accept("./PublishSharedLink.vue?vue&type=template&id=d7bf1480&scoped=true", function () {
      api.rerender('d7bf1480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PublishSharedLink.vue"
export default component.exports